/*
  Oak Astro: links to the EU withdrawal page open the Revoq withdrawal form pop-up,
  the same form as the app's floating "Withdraw contract" button.
  If the Revoq app is not loaded, the link opens the page as normal.
*/
(function () {
  var path = (document.documentElement.getAttribute('data-oa-withdrawal-path') || '').trim();
  if (!path) return;

  function normalise(p) {
    return p.replace(/\/+$/, '').toLowerCase();
  }

  var target = normalise(path);

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!link) return;

      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin || normalise(url.pathname) !== target) return;

      var revoq = window.RevoqWithdrawal;
      if (revoq && typeof revoq.open === 'function') {
        event.preventDefault();
        event.stopPropagation();
        // Close Dawn's mobile menu drawer first if the link was inside it.
        var drawer = link.closest('details[open]');
        if (drawer) drawer.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
        revoq.open();
      }
    },
    true
  );
})();
